const TIMEOUT_TENTATIVA_MS = 15000;
const INTERVALO_MS = 1000;
const LIMITE_MS = 60000;
const SPLASH_MINIMO_MS = 2600;

function esperar(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function servidorResponde(url) {
  const controle = new AbortController();
  const timer = setTimeout(() => controle.abort(), TIMEOUT_TENTATIVA_MS);
  try {
    const resposta = await fetch(url, { signal: controle.signal });
    return resposta.ok;
  } catch (e) {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

// fetch em vez da instância do axios: o interceptor dela exibe um toast a cada falha.
export async function aguardarServidor(baseUrl) {
  const url = `${baseUrl}/health`;
  const inicio = Date.now();
  while (Date.now() - inicio < LIMITE_MS) {
    if (await servidorResponde(url)) {
      return true;
    }
    await esperar(INTERVALO_MS);
  }
  return false;
}

export function aguardarSplashMinimo() {
  return esperar(Math.max(0, SPLASH_MINIMO_MS - performance.now()));
}
